import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=28b4d0fa"
import script from "./echarts.vue?vue&type=script&lang=js"
export * from "./echarts.vue?vue&type=script&lang=js"
import style0 from "./echarts.vue?vue&type=style&index=0&id=28b4d0fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports